import { Box,Circle } from "@chakra-ui/layout";

import { Select } from "@chakra-ui/select";
import { useEffect, useRef, useState } from "react";
import { loadTeachers, setTeacher } from "../../redux/api_calls/apiCalls";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton
} from "@chakra-ui/react";
import { useDisclosure } from '@chakra-ui/react'
import { ReactComponent as Edit } from '../../svg/plus.svg';

export default function ScheduleSlot({ slotId, sessionId, classId, slot, subjects , degree , specification }) {
    const [selectedValue, setSelectedValue] = useState('0')
    const [subjectTeachers, setSubjectTeachers] = useState([])
    const [selectedTeacher, setSelectedTeacher] = useState('0')
    const slotRef = useRef()
    const teacherRef = useRef()
    const { isOpen, onOpen, onClose } = useDisclosure();
    const subjectChangeHandler = () => {
        setSubjectTeachers([])
        setSelectedValue(slotRef.current.value)
    }

    const getSubjectTeachers = async () => {
        try {
            let response = await loadTeachers(selectedValue)
            setSubjectTeachers(response)
        }
        catch (error) {
            console.log(error)
        }
    }

    const setSlotTeacher = async () => {
        try {
            let response = await setTeacher(classId, selectedTeacher, sessionId, selectedValue, slot,degree,specification)
            if(response){
                 onClose();
                alert("Teacher assigned")
            }
        }
        catch (error) {
            alert(error.message)
        }
    }

    const teacherChangeHandler = () => {
        setSelectedTeacher(teacherRef.current.value)
    }

    useEffect(() => {
        if (selectedValue !== '0') {
            getSubjectTeachers()
        }
        // eslint-disable-next-line
    }, [selectedValue])

    useEffect(() => {
        if (selectedTeacher !== '0') {
            setSlotTeacher()
        }
        // eslint-disable-next-line
    }, [selectedTeacher])
    const handleSizeClick = newSize => {
    onOpen();
  };
    return (
        <Box
      borderLeft='1px solid rgba(0,0,0,0.1)'
      flex='1'
      height='160px'
      display='flex'
      flexDir='column'
      justifyContent='center'
      alignItems='center'
      py='2'
      //   backgroundColor={subject ? 'white' : 'lightgray'}
      style={{ fontFamily: 'Mulish, sans-serif' }}
    >
    <Circle
            cursor='pointer'
            width='30px'
            display= 'flex' 
            height='30px'
            borderRadius='50%'
            bg=' #ECF5FC'
             onClick={() => handleSizeClick(sessionId)}
             icon={<Edit/>}
          >
          <Edit/>
    </Circle>
    <Modal onClose={onClose} id={sessionId} isOpen={isOpen} position="center" style={{position: 'absolute', top: '50%', left: '50%'}}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Add Schedule</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Select
                id='type'
                width={["100%", "100%", "90%", "85%"]}
                border='1px solid rgba(0, 0, 0, 0.1)'
                borderRadius="13px"
                height='40px'
                ref={slotRef}
                value={selectedValue}
                onChange={subjectChangeHandler}
                fontSize='14px'
                style={{ fontFamily: 'Mulish, sans-serif' }}
            >
                <option value='0' key='-1'>Select a Subject</option>
                {
                    subjects.map((subject, idx) => <option value={subject.id} key={idx}>{subject.name}</option>)
                }
            </Select>

            <Select
                id='type'
                width={["100%", "100%", "90%", "85%"]}
                border='1px solid rgba(0, 0, 0, 0.1)'
                borderRadius="13px"
                height='40px'
                ref={teacherRef}
                value={selectedTeacher}
                disabled={subjectTeachers.length === 0}
                onChange={teacherChangeHandler}
                fontSize='14px'
                style={{ fontFamily: 'Mulish, sans-serif' }}
                marginTop='10px'
            >
                <option value='0' key='-1'>Select a Teacher</option>
                {
                    subjectTeachers.map((teacher, idx) => <option value={teacher.id} key={idx}>{teacher.first_name} {teacher.last_name}</option>)
                }
            </Select>
            </ModalBody>
          <ModalFooter>
          </ModalFooter>
        </ModalContent>
      </Modal>
            
        </Box>
    )
}